export default __webpack_public_path__ + "static/media/lemon_odyssey.6bd52498.png";